import CorporateResource from "./corporate.resource";

const corporateModule = angular
  .module("app.resources.corporate", [])
  .service("Corporate", CorporateResource);

export default corporateModule;



// WEBPACK FOOTER //
// ./src/resources/corporate/corporate.module.js